export const areas = [
  {
    id: '1',
    nombre: 'CIENCIAS NATURALES',
    slug: 'ciencias-naturales',
  },
  {
    id: '2',
    nombre: 'INGENIERÍA, TECNOLOGÍA',
    slug: 'ingenieria-tecnologia',
  },
  {
    id: '3',
    nombre: 'CIENCIAS MÉDICAS, CIENCIAS DE LA SALUD',
    slug: 'ciencias-medicas-salud',
  },
  {
    id: '4',
    nombre: 'CIENCIAS AGRARIAS',
    slug: 'ciencias-agrarias',
  },
  {
    id: '5',
    nombre: 'CIENCIAS SOCIALES',
    slug: 'ciencias-sociales',
  },
  {
    id: '6',
    nombre: 'HUMANIDADES',
    slug: 'humanidades',
  },
];
export const programasConst = [
  {
    id: 1,
    area: '3',
    descripcion:
      'La comunidad universitaria de la Facultad de Medicina de la Universidad de Antioquia aspira a formar excelentes médicos generales que: -Sean profesionales íntegros en el ser y en el hacer. autónomos. reflexivos. críticos. que sepan escuchar. cuestionar y disfrutar. -Muestren capacidad de trabajar en forma interdisciplinaria para intervenir en el proceso salud/enfermedad en el ser humano desde la promoción. prevención. tratamiento y rehabilitación. con el fin de actuar como agentes de cambio para mejorar la calidad de vida de la comunidad. -Propendan a las relaciones democráticas y éticas con las personas y con la sociedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FMED_01.jpg?alt=media&token=30454582-84c1-41ce-91ef-3e59eeeda24f',
    urlVideo: 'https://www.youtube.com/embed/tBUD0M3hesI',
    facultad: 'Facultad de medicina',
    pregrado: 'MEDICINA',
  },
  {
    id: 2,
    area: '6',
    descripcion:
      'Licenciatura en Literatura y Lengua Castellana centra su interés en la formación de maestros desde una concepción del lenguaje que articula las dimensiones éticas. estética y lógica. y que propicia la sensibilidad. la lectura crítica de los contextos socioculturales. la comprensión del mundo y de la propia experiencia. En coherencia con la misión de la Facultad de Educación. la Licenciatura en Literatura y Lengua Castellana forma maestros críticos y propositivos para los niveles de la básica. la media y otros contextos en los que opera la relación formación y lenguaje en sus dimensiones ética. estética y lógica. mediante la investigación como eje articulador que propicia la comprensión y acción en diferentes contextos socioculturales para aportar a los procesos educativos en el departamento y el país.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_LENGUA_CAST.jpg?alt=media&token=56b60df2-1e10-4ba1-b016-7bae90e2e9bb',
    urlVideo: 'https://www.youtube.com/embed/7DIuPvsCnHc',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN LITERATURA Y LENGUA CASTELLANA',
  },
  {
    id: 3,
    area: '5',
    descripcion:
      'La Licenciatura en Educación Básica con Énfasis en Ciencias Sociales define su misión desde el marco misional de la Universidad de Antioquia y de la Facultad de Educación a las que pertenece. Asume como rasgo particular la reflexión sobre la educabilidad y la enseñabilidad de las Ciencias Sociales y ofrece el servicio público de la formación integral de maestros en Ciencias Sociales para desempañarse en distintos niveles y contextos educativos. mediante el ejercicio de la docencia. la investigación y la extensión.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FLIC_CCIAS_SOC.jpg?alt=media&token=6d8f4687-bae4-46b3-bd32-388c2b0ca018',
    urlVideo: 'https://www.youtube.com/embed/n9ePCXU8_QI',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN CIENCIAS SOCIALES',
  },
  {
    id: 4,
    area: '5',
    descripcion:
      'Formar desde una perspectiva humanista y una sólida fundamentación en los saberes disciplinares y meta-disciplinares. maestros autónomos. capaces de liderar los cambios pedagógicos y didácticos que propicien la participación crítica e informada de la población escolar en los debates sociales y ambientales. que comporta la ciencia en el mundo contemporáneo.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FLIC_CCIAS_NAT.jpg?alt=media&token=46132bb6-636b-439e-b5f0-68d4481202a5',
    urlVideo: 'https://www.youtube.com/embed/B3xzCEQV8h0',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN CIENCIAS NATURALES',
  },
  {
    id: 5,
    area: '2',
    descripcion:
      'La ingeniería oceanográfica es la rama de la ingeniería que combina el conocimiento de la química, la biología, la geología y la física del océano con la ingeniería, con el objetivo de lograr un desarrollo sostenible de la franja tierra-océano, teniendo en cuenta sus dimensiones ecológicas, sociales, económicas y tecnológicas. La ingeniería oceanográfica congrega el conocimiento de la dinámica marina, su interacción con las obras y estructuras y el medio terrestre, y los métodos de proyecto y construcción de obras portuarias, estructuras en mar abierto, de protección y estabilización de costas.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_OCEANO.jpg?alt=media&token=f0397210-5dd8-462f-a593-91b30aa50362',
    urlVideo: 'https://www.youtube.com/embed/NbH1B4158CM',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA OCEANOGRÁFICA',
  },
  {
    id: 6,
    area: '1',
    descripcion:
      'El estadístico egresado de este programa será capaz de utilizar teoría estadística con sólida formación matemática y habilidades para generar soluciones a los problemas que demanda el entorno, generar y ejecutar investigaciones en áreas específicas de estadística y temas afines. Además, tendrán formación que les facilite continuar con sus estudios de posgrado.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FESTADISTICA.jpg?alt=media&token=28a33f34-f2d4-4bd4-abf0-0d479eecaa69',
    urlVideo: 'https://www.youtube.com/embed/iUWEed3E3Mk',
    facultad: 'Facultad de ciencias exactas y naturales',
    pregrado: 'ESTADÍSTICA',
  },
  {
    id: 7,
    area: '3',
    descripcion:
      'Los egresados del programa de Estadística podrán desempeñarse en el sector público y privado de la industria, la docencia y la investigación en instituciones de nivel superior. También podrá realizar actividades de planeación, investigador o consultor de manera independiente en el área de la estadística',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FENFERM_02.jpg?alt=media&token=0865b0c7-f193-48a2-a1c0-98b7d6976433',
    urlVideo: 'https://www.youtube.com/embed/V2GGDFrdI4g',
    facultad: 'Facultad de enfermería',
    pregrado: 'ENFERMERÍA',
  },
  {
    id: 8,
    area: '5',
    descripcion:
      'El perfil profesional de los egresados del programa de Economía está orientado a: 1. Generación de información: profesional que construye información útil para la toma de decisiones. 2. Transformación económica y social: profesional que interpreta los contextos de su sociedad para liderar cambios económicos y sociales en diversas organizaciones. 3. Generación de conocimiento: profesional que desarrolla procesos de investigación y consultoría en un marco científico riguroso y ético.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FECONO.jpg?alt=media&token=cc058b1f-50fb-43d9-8b9d-0310a8b035db',
    urlVideo: 'https://www.youtube.com/embed/-a-LLIbwGPM',
    facultad: 'Facultad de ciencias económicas',
    pregrado: 'ECONOMÍA',
  },
  {
    id: 9,
    area: '5',
    descripcion:
      'El objeto de estudio del Programa es la Comunicación en el contexto de la sociedad y de la cultura. en los ámbitos regional. nacional y mundial. la cual se configura a partir de los procesos comunicativos entre los diversos interlocutores (individuos. organizaciones. comunidades). los procesos de percepción (activa. crítica...). la producción de sentido e intención de emisión. las características de los mensajes (códigos. contenidos. estilo...) la dimensión pública de los procesos comunicativos y sus implicaciones en el desarrollo humano y la formación ciudadana. la emisión de mensajes. mediatizados o directos. y las características técnicas y tecnológicas de los medios y sus implicaciones en el acontecer diario de las personas y los grupos humanos que entran en contacto.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FCOMUNIC.jpg?alt=media&token=d6d0014f-9cf9-4cc9-8dba-10127cb16d53',
    urlVideo: 'https://www.youtube.com/embed/uhYXShThjFk',
    facultad: 'Facultad de comunicaciones',
    pregrado: 'COMUNICACIONES',
  },
  {
    id: 10,
    area: '5',
    descripcion:
      'El mundo audiovisual y el informático permiten pensar las actividades pedagógicas. didácticas y curriculares de un pregrado desde diferentes perspectivas. enfocadas a partir de disciplinas creativas que lleven a repensar la expresión desde el hacer y desde el ejercicio mismo del ser creativo. Lo que propone el pregrado de Comunicación Audiovisual y Multimedial es la expresión o ejercicio libre de la sensibilidad hacia el acto creativo en el cual el profesor es guía. iniciador y orientador de proyectos trabajados desde la base de los talleres. que son alimentados a su vez por diferentes paradigmas comunicacionales. lingüísticos. tecnológicos y socio-humanísticos.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FCOMUNI_AUDIOVIS.jpg?alt=media&token=cb46cc67-4c67-404c-8fbc-afebb0485564',
    urlVideo: 'https://www.youtube.com/embed/5TXFixn8b4c',
    facultad: 'Facultad de comunicaciones',
    pregrado: 'COMUNICACIÓN AUDIOVISUAL Y MULTIMEDIAL',
  },
  {
    id: 11,
    area: '1',
    descripcion:
      'El biólogo de la Universidad de Antioquia posee una sólida fundamentación básica y epistemológica; entiende que su disciplina tiene como marco la evolución orgánica. Su solvencia conceptual y metodológica estará matizada por el énfasis en al menos una de las siguientes áreas: 1) Genética. Biología Celular y Molecular; 2) Sistemática; 3) Ecología de Poblaciones. Comunidades y Ecosistemas; 4) Biotecnología.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FBIOLOGIA.jpg?alt=media&token=ac2ad8f0-5c7e-4408-9ff6-e972ab9213a8',
    urlVideo: 'https://www.youtube.com/embed/uSG0LGg6TLw',
    facultad: 'Facultad de ciencias exactas y naturales',
    pregrado: 'BIOLOGÍA',
  },
  {
    id: 12,
    area: '2',
    descripcion:
      'El objeto propio de la Bioingeniería consiste en la comprensión y aplicación de los conocimientos en ciencias exactas y naturales y de la ingeniería para el análisis. diseño. simulación. implementación y optimización de procesos. procedimientos. equipos y sistemas. que incorporen las diferentes tecnologías bioelectrónicas. biomecánicas y de los biomateriales. con el fin de generar bienestar. desarrollo tecnológico y social sostenibles en los sectores bioindustrial. médico-asistencial y de biodiversidad.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/ML8wTnzhHD8',
    facultad: 'Facultad de ingeniería',
    pregrado: 'BIOINGENIERÍA',
  },
  {
    id: 13,
    area: '1',
    descripcion:
      'Formación de profesionales con una concepción integral del hombre. orientados al servicio de la comunidad con una actitud humana. que reconocen el lugar y tiempo que ocupa nuestro planeta y especie en el Universo. competentes para plantear y resolver problemas de manera efectiva e innovadora. capaces de contribuir de formas originales al entendimiento del Universo y/o a la educación y divulgación en el seno de nuestra sociedad de ese mismo conocimiento.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FASTRONOMIA.jpg?alt=media&token=fdfebac4-8e6b-40f6-8fc8-cee87dc4438e',
    urlVideo: 'https://www.youtube.com/embed/ruU9ic5WilE',
    facultad: 'Facultad de ciencias exactas y naturales',
    pregrado: 'ASTRONOMÍA',
  },
  {
    id: 14,
    area: '5',
    descripcion:
      'El egresado del programa de Antropología está en condiciones de asumir roles ocupacionales diversos relacionados con el estudio de la vida social y de la cultura. y con la intervención en procesos relacionados con estos ámbitos. Desde una visión global. las posiciones o funciones profesionales en las que está capacitado para desenvolverse pueden resumirse así: ser Investigador de problemáticas en los diversos campos de la antropología; ser gestor. ejecutor. asesor o consultor de políticas. instituciones. programas o proyectos en el campo sociocultural; ser instructor de promotores o gestores sociales o culturales.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/bm_UxO5wIqU',
    facultad: 'Facultad de ciencias sociales y humanas',
    pregrado: 'ANTROPOLOGÍA',
  },
  {
    id: 15,
    area: '4',
    descripcion:
      'El programa de Medicina Veterinarias de la Universidad de Antioquia tiene como objetivo fundamental la formación de médicos veterinarios con un enfoque del ejercicio veterinario en el ámbito nacional e internacional, que responda además a las demandas de prestación de servicios veterinarios específicas del sector pecuario colombiano, que tenga presente su compromiso social con las comunidades de productores menos favorecidas. De igual modo, que propenda por el cuidado y la preservación de la salud de los animales, la biodiversidad, los ecosistemas y la producción de alimentos de origen animal con criterios de sostenibilidad. Para el efecto, de le brinda al estudiante un ambiente académico en donde se combinan diferentes estrategias didácticas que garantizan su conceptualización teórica y el entrenamiento en la praxis veterinaria, entre las que se incluye el aprendizaje basado en problemas, el Espacio curricular de integración, el aprendizaje basado en evidencias, la clase magistral y la formación autodidacta. Por la inclusión de la investigación como eje integrador de su formación, desarrolla una gran capacidad crítica ante los problemas propios del ejercicio veterinario y de las comunidades objeto del campo de acción de su ejercicio profesional.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20agricolas%2FMED_VET_02.jpg?alt=media&token=ee4ac443-88c3-4165-939a-af1e3165cd11',
    urlVideo: 'https://www.youtube.com/embed/ibB1636iC9k',
    facultad: 'Facultad de ciencias agrarias',
    pregrado: 'MEDICINA VETERINARIA',
  },
  {
    id: 16,
    area: '6',
    descripcion:
      'El egresado del programa Traducción inglés-francés-español está preparado para traducir de manera escrita en las lenguas de formación. Posee conocimiento en las nuevas tecnologías de la información y de la comunicación. así como de la terminología y la documentación como herramientas fundamentales para las labores específicas de traducción. En el área de la investigación. se integra a grupos interdisciplinarios. genera y ejecuta proyectos de investigación que tengan como objeto la generación de conocimientos y la solución de problemas del área del saber.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FTRADUCCION.jpg?alt=media&token=9bd2c3a7-642d-4182-807e-06240a2b08c6',
    urlVideo: 'https://www.youtube.com/embed/pjLdCP6C9Hc',
    facultad: 'Escuela de idiomas',
    pregrado: 'TRADUCCIÓN INGLÉS - FRANCÉS - ESPAÑOL',
  },
  {
    id: 17,
    area: '5',
    descripcion:
      'De acuerdo con el plan de desarrollo del programa “El Departamento de Sociología de la Universidad de Antioquia es un espacio académico y cultural destinado a producir y enriquecer el pensamiento sociológico. a generar interpretaciones y análisis críticos de la realidad social. nacional y regional. desde la perspectiva de un saber disciplinar que se apoya en una tradición crítica y que busca propiciar condiciones para la intervención social en la idea de crear potencialidades de calidad de vida y desarrollo sostenibles para la población colombiana”.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FSOCIOLOGIA.jpg?alt=media&token=babc43db-1cc9-43b7-b512-a764855264d7',
    urlVideo: 'https://www.youtube.com/embed/BfJwjMAb6-Y',
    facultad: 'Facultad de ciencias sociales y humanas',
    pregrado: 'SOCIOLOGÍA',
  },
  {
    id: 18,
    area: '1',
    descripcion:
      'El Microbiólogo y Bioanalista de la Universidad de Antioquia se concibe como un profesional: 1. Idóneo técnico-administrativa y científicamente. para desempeñarse en laboratorios de primero. segundo y tercer nivel de complejidad. 2. Con fortaleza en ciencia básica. 3. Con capacidad de aportar a la construcción de su objeto de estudio. 4. Con capacidad de abstracción. 5. Con pensamiento lógico y sistémico. 6. Interdisciplinario. 7. Capaz de identificar problemas de salud del entorno social local y regional. y de presentar propuestas de investigación o de desarrollo que contribuyan a resolverlos.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FMICROBIOL.jpg?alt=media&token=9383f7c5-f16c-4b8c-a0c3-024e77a70122',
    urlVideo: 'https://www.youtube.com/embed/6hBxBIceGss',
    facultad: 'Escuela de microbiología',
    pregrado: 'MICROBIOLOGÍA Y BIOANÁLISIS',
  },
  {
    id: 19,
    area: '5',
    descripcion:
      'En consonancia con la misión planteada desde la Facultad. la Licenciatura de Educación Especial. tiene como misión Formar maestros y maestras para los procesos educativos. formativos. de enseñanza y aprendizaje de las personas con discapacidad y con capacidades y talentos excepcionales posibilitando así. el reconocimiento político de sus diferencias y la inclusión social y educativa.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FLIC_ED_ESP.jpg?alt=media&token=505f63e4-dcdd-4832-a31b-bd0fc6834932',
    urlVideo: 'https://www.youtube.com/embed/iYB7tiJoLXM',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN EDUCACIÓN ESPECIAL',
  },
  {
    id: 20,
    area: '2',
    descripcion:
      'El objeto principal del programa de Ingeniería Urbana de la Universidad de Antioquia es combinar los principios de la ingeniería y el Urbanismo en la creación, planificación, y gestión de ciudades y regiones de manera sostenible combinando saberes humanísticos, técnicos y científicos. El programa tendrá una mirada holística e integradora de los diferentes elementos que conforman el “sistema urbano”, con una sólida formación en el conocimiento del territorio en sus aspectos físico, ambiental y social, que permita usar herramientas de planificación y control del desarrollo urbano regional, incluyendo el estudio de necesidades y usos de la infraestructura para el desarrollo de las actividades socioeconómicas propias del entorno urbano, en consonancia con los recursos naturales, buscando obtener un desarrollo sostenible de la región y una inversión óptima de los recursos públicos destinados a obras de infraestructura.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_URBANA.jpg?alt=media&token=fc9e5f5c-8544-4eb2-9012-3ec840d8f55e',
    urlVideo: 'https://www.youtube.com/embed/42Nm16RaN1E',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA URBANA',
  },
  {
    id: 21,
    area: '2',
    descripcion:
      'Ingeniería de Sistemas tiene como objeto el estudio de elementos en ciencia y tecnología para la investigación. innovación. modelación. implantación y gestión de sistemas físicos o abstractos. orientados al procesamiento simbólico; concebidos en consonancia con criterios estéticos. económicos. culturales y de respeto del entorno.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_SIST.jpg?alt=media&token=29e53c5f-e311-47ae-9e8f-c0097881d004',
    urlVideo: 'https://www.youtube.com/embed/PtMdsboOZdk',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA DE SISTEMAS',
  },
  {
    id: 22,
    area: '6',
    descripcion:
      'El Programa Arte Dramático está orientado a la formación de actores y actrices. capaces de reflexionar. incidir. transformar y aportar a nuestra realidad cultural y específicamente teatral. El programa hace énfasis en la formación de actores actrices - creadores e investigadores- con las capacidades. habilidades y destrezas intelectuales. técnicas. sensibles. éticas y humanas para la formulación y realización de procesos y proyectos de creación escénica. investigación artística y gestión cultural.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FARTE_DRAMA.jpg?alt=media&token=28a040e4-b8d5-4a2e-bf4f-5eb459347759',
    urlVideo: 'https://www.youtube.com/embed/Q2uf2lUsU8s',
    facultad: 'Facultad de artes',
    pregrado: 'ARTE DRAMÁTICO',
  },
  {
    id: 23,
    area: '3',
    descripcion:
      'El egresado en entrenamiento deportivo será un agente de transformación social. no sólo en el campo de la teoría y la práctica del entrenamiento deportivo y del deporte sino en todos los campos de la sociedad en que se incluya. a través de su actitud pedagógica. su disciplina y su orientación hacia el emprendimiento y al trabajo en equipo. Estará en capacidad de programar. ejecutar. controlar y proponer y desarrollar proyectos en torno a las fases de iniciación. formación. especialización. logros y resultados élite. dentro del deporte de representación. competencia y deporte élite.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FDEPORTIVO_02.jpg?alt=media&token=be737d97-e8d5-426a-bf1a-349fddf9c8dd',
    urlVideo: 'https://www.youtube.com/embed/vzxMHJCH2OU',
    facultad: 'Instituto universitario de educación física y deporte',
    pregrado: 'ENTRENAMIENTO DEPORTIVO',
  },
  {
    id: 24,
    area: '2',
    descripcion:
      'La dinámica en el sector aeroespacial que está ocurriendo tanto en el país como a nivel global, llevaron a la Universidad de Antioquia a tomar la decisión de implementar un nuevo pregrado de Ingeniería Aeroespacial, primero de su tipo en Colombia.  Si bien en el país, en el área ya existen desde hace casi dos décadas programas de Ingeniería Aeronáutica, que por su naturaleza hacen parte del sector, el programa de la Universidad de Antioquia es el primero con la denominación Ingeniería Aeroespacial, lo cual no es sólo un asunto de denominación reconocida en el registro calificado del programa, el cual, impartió el Ministerio de Educación Nacional en el año 2016 (Resolución número 19796 del 18 de octubre de 2016), sino que es el primero en la comunidad de países andinos, que incluye dentro de sus metas de formación profesional y  diseño curricular,  una formación completa tanto en el campo aeronáutico como de ingeniería espacial.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_AEROESPACIAL.jpg?alt=media&token=4bd1462c-261c-421c-86ab-3f5f121cadd5',
    urlVideo: 'https://www.youtube.com/embed/gu3yJ0dyfbQ',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA AEROESPACIAL',
  },
  {
    id: 25,
    area: '3',
    descripcion:
      'Los estudios en esta materia abordan los procesos de instrumentación de cirugías en áreas quirúrgicas hospitalarias. algunos de los cuales son: instrumentación. asepsia. desinfección. esterilización y bioseguridad. y preparan para que los profesionales puedan interactuar eficientemente con equipos de salud orientados a mejorar las condiciones de vida del paciente tratado quirúrgicamente.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FINST_QUIR.jpg?alt=media&token=3b7c2e1b-7c5d-4d78-b1af-449795fe93a0',
    urlVideo: 'https://www.youtube.com/embed/kTSg8iLC3m8',
    facultad: 'Facultad de medicina',
    pregrado: 'INSTRUMENTACIÓN QUIRÚRGICA',
  },
  {
    id: 1,
    area: '6',
    descripcion:
      'Los profesionales de la Historia deben contribuir al conocimiento y construcción de la nación asumiendo su oficio con responsabilidad ética. moral y crítica. por medio de los debates y escritos académicos que den cuenta de las corrientes de pensamiento y del respeto por las diversas posiciones académicas y políticas en la construcción del conocimiento histórico. Historiadores capaces de comprender la complejidad de los fenómenos sociales. políticos. económicos y culturales del pasado. permitiendo la aplicación de postulados teórico-metodológicos propios de las ciencias sociales. capaces de brindar aportes específicos a la Historia con enfoque interdisciplinario y transdisciplinario.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FHISTORIA.jpg?alt=media&token=aad571a1-e692-4b3b-b223-4ef328769cb6',
    urlVideo: 'https://www.youtube.com/embed/2wmRfsBsTaY',
    facultad: 'Facultad de ciencias sociales y humanas',
    pregrado: 'HISTORIA',
  },
  {
    id: 26,
    area: '2',
    descripcion:
      'El egresado de Ingeniería de Materiales. cuenta con los fundamentos teóricos y prácticos sobre las etapas de preparación. caracterización. simulación. manejo de materias primas. y procesamiento de los materiales para su aplicación en cualquier campo de la ingeniería con competencias humanísticas y técnicas acordes a los requerimientos sociales y ambientales de la industria.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_MAT.jpg?alt=media&token=d7f6edc9-2e9d-49af-beb1-85de14620ac4',
    urlVideo: 'https://www.youtube.com/embed/zWXPqhoJPSw',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA DE MATERIALES',
  },
  {
    id: 27,
    area: '6',
    descripcion:
      'El programa de Licenciatura en Educación Artes Plásticas tiene el propósito de formar docentes en pedagogía de las artes. conocedores y críticos de la realidad histórica y social del país. de su desarrollo y de la historia de la educación artística. comprometidos con el desarrollo social y cultural. y con una clara posición ética y estética que se refleje en su compromiso para pensar los problemas propios de la enseñanza de las artes.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_ARTES_PLAST.jpg?alt=media&token=f177b03a-d071-495e-a57d-de9e733a5765',
    urlVideo: 'https://www.youtube.com/embed/idMfY8CJ3a8',
    facultad: 'Facultad de artes',
    pregrado: 'LICENCIATURA EN ARTES PLÁSTICAS',
  },
  {
    id: 28,
    area: '6',
    descripcion:
      'El programa Música se ha creado para proveer una formación íntegra de profesionales. creadores. intérpretes e investigadores. que contribuyan al desarrollo de los procesos artísticos de la región y del país. Con un cuerpo de profesores altamente calificados. ofrece líneas de formación en los diferentes instrumentos musicales. la composición y la dirección.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FMUSICA.jpg?alt=media&token=ed6b8941-7e38-41a8-af6c-a17f42d2b041',
    urlVideo: 'https://www.youtube.com/embed/Ag-OzVpElyE',
    facultad: 'Facultad de artes',
    pregrado: 'MÚSICA',
  },
  {
    id: 29,
    area: '2',
    descripcion:
      'El profesional egresado como Ingeniero de Alimentos. posee una sólida estructura científica y técnica enmarcada en una fundamentación humanística e investigativa. es un ciudadano ético. creativo. racional. crítico. con sensibilidad social. con conocimiento en la ingeniería. procesos alimentarios. aseguramiento de la calidad y administración. con profundo respeto por su entorno. capacidad de interactuar en grupos interdisciplinarios. investigar. desarrollar. diseñar. implementar y optimizar las más avanzadas tecnologías limpias y de punta.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_ALIMENTOS.jpg?alt=media&token=d254061e-b5a5-4183-93c3-d715c1e478b9',
    urlVideo: 'https://www.youtube.com/embed/Mbs04V2G0kM',
    facultad: 'Facultad de ciencias farmacéuticas y alimentarias',
    pregrado: 'INGENIERÍA DE ALIMENTOS',
  },
  {
    id: 30,
    area: '2',
    descripcion:
      'El ingeniero electricista de la Universidad de Antioquia está en capacidad de desempeñarse en actividades de dirección. diseño. planeación. construcción. mantenimiento. consultoría. interventoría e investigación asociadas a la generación. transmisión. distribución. comercialización y utilización de la energía eléctrica. en la optimización. automatización y control de procesos industriales y sistemas eléctricos. Con iniciativa para crear empresa y desempeñarse en empresas de servicio de energía eléctrica. de comunicaciones. fabricantes de equipos eléctricos. firmas de consultoría. industrias de transporte y procesamiento. docencia e investigación del sector público y privado.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_ELECTRICA.jpg?alt=media&token=1b4b3b06-cd2f-4bd7-b832-7a7b23d21570',
    urlVideo: 'https://www.youtube.com/embed/6INopxHY4mc',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA ELÉCTRICA',
  },
  {
    id: 31,
    area: '2',
    descripcion:
      'El objetivo principal del departamento de ingeniería eléctrica está enfocado en la formación de un profesional con conocimientos científicos y tecnológicos que lo capaciten para analizar. evaluar. diseñar. apropiar tecnología. integrar dispositivos y subsistemas de hardware para aportar soluciones a necesidades en: procesamiento de la información. innovaciones de la instrumentación para medición y automatización de procesos. conectividad y compatibilidad entre equipos. control y monitoreo de variables procesadas por dispositivos y sistemas electrónicos. homologación y certificación de especificaciones técnicas de equipos electrónicos. Actualmente y debido a la necesidad de insertar el ingeniero electrónico en un entorno económico globalizado. se hace necesario que éste. maneje una segunda lengua. preferentemente el inglés y tenga una formación en gestión tecnológica. que lo capacite para formar empresa.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_ELECTRONICA.jpg?alt=media&token=bf842dc7-677c-4d76-a760-36603f3c6f35',
    urlVideo: 'https://www.youtube.com/embed/5-u36BcgZSs',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA ELECTRÓNICA',
  },
  {
    id: 32,
    area: '2',
    descripcion:
      'Formar Ingenieros Mecánicos capaces de aplicar. transferir y desarrollar conocimiento en el ámbito nacional e internacional en las áreas de Materiales de Ingeniería y Tecnologías Avanzadas de fabricación. generación. transformación y uso racional y eficiente de la energía. control y automatización de Procesos Industriales. diseño. fabricación. montaje. operación y mantenimiento de sistemas mecánicos mediante la investigación. desarrollo e innovación en armonía con el medio ambiente',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_MECANICA.jpg?alt=media&token=0d633886-4341-400b-a519-a7c804a78c2c',
    urlVideo: 'https://www.youtube.com/embed/6xhuTmH1gp4',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA MECÁNICA',
  },
  {
    id: 33,
    area: '6',
    descripcion:
      'El programa Arte Dramático del Departamento de Artes Escénicas de la Facultad de Artes de la Universidad de Antioquia está orientado a la formación de actores y actrices, capaces de reflexionar, incidir, transformar y aportar a nuestra realidad cultural y específicamente teatral. El programa hace énfasis en la formación de actores y actrices creadores e investigadores con las capacidades, habilidades y destrezas intelectuales, técnicas, sensibles, éticas y humanas para la formulación y realización de procesos y proyectos de creación escénica, educación artística, investigación artística y gestión cultural.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FARTES_ESCENICAS.jpg?alt=media&token=6ab7c968-6fb1-4ca1-99bc-d5c4d01fe970',
    urlVideo: 'https://www.youtube.com/embed/RsLex6jHtDc',
    facultad: 'Facultad de artes',
    pregrado: 'LICENCIATURA EN ARTES ESCÉNICAS',
  },
  {
    id: 34,
    area: '6',
    descripcion:
      'El programa Licenciatura en Educación Básica en Danza busca formar profesionales integrales con conocimientos sobre la enseñanza. interpretación. puesta en escena e investigación de la danza. Ofrece a los estudiantes la formación en técnicas y teorías de los principales géneros. con un claro enfoque dirigido al desarrollo de la danza contemporánea como línea de enseñanza. interpretación y creación.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_DANZA.jpg?alt=media&token=49ff5d2b-1dc5-4fdb-974b-080449768b69',
    urlVideo: 'https://www.youtube.com/embed/qQrT1fH91sc',
    facultad: 'Facultad de artes',
    pregrado: 'LICENCIATURA EN DANZA',
  },
  {
    id: 35,
    area: '1',
    descripcion:
      'El Matemático de la Universidad de Antioquia estará en capacidad de: contribuir al progreso del país y de la región mediante la docencia a nivel universitario en las diferentes carreras científicas. tecnológicas y/o humanísticas. así como en la formación básica y media; participar en grupos de investigación. en la generación de ideas. modelos y en la solución de problemas; trabajar en asesorías y consultorías en el sector académico y empresarial. a través de tecnologías informáticas y de comunicación; proseguir estudios de posgrado en matemáticas y áreas afines.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FMAT.jpg?alt=media&token=fff8b292-74a1-4562-9f8c-bcfb6059e96d',
    urlVideo: 'https://www.youtube.com/embed/CkiUiT3dT8E',
    facultad: 'Facultad de ciencias exactas y naturales',
    pregrado: 'MATEMÁTICAS',
  },
  {
    id: 36,
    area: '6',
    descripcion:
      'El programa Música Canto propende por la formación de jóvenes cantantes. haciendo énfasis en aspectos que tienen que ver con su desarrollo técnico e interpretativo. su expresión corporal. el dominio escénico. el conocimiento de la dicción de lenguas extranjeras pertinentes a su repertorio y el ensamble de su voz en diferentes formatos de conjuntos vocales y vocales instrumentales. Ofrece dos líneas de formación: Canto lírico y Canto popular.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FCANTO.jpg?alt=media&token=9894e737-c90e-407e-aac9-2fa0764950f3',
    urlVideo: 'https://www.youtube.com/embed/soUD96fJgAE',
    facultad: 'Facultad de artes',
    pregrado: 'MÚSICA - CANTO',
  },
  {
    id: 37,
    area: '4',
    descripcion:
      'El programa de Zootecnia adscrito a la Facultad de Ciencias Agrarias de la Universidad de Antioquia. está comprometido con la formación profesional. ética. social. humanística y científica de los estudiantes. con disposición permanente y gran sentido de responsabilidad y compromiso. con una clara visión social. en la búsqueda de soluciones a la problemática del sector y al mejoramiento de la calidad de vida de la población. bajo criterios de productividad. competitividad y sostenibilidad ambiental. respetando los principios de la convivencia y la igualdad ciudadana. El programa de Zootecnia debe participar en los planes de desarrollo regionales y nacionales e incorporarse en las cadenas productivas del sector pecuario y estar atento a las oportunidades que se originan con los procesos de globalización de la economía. con el fin de responder a las necesidades generadas por los inmensos recursos agropecuarios que poseen el Departamento de Antioquia y el país. promoviendo acciones interdisciplinarias de investigación. de docencia. de extensión. de desarrollo tecnológico y de desarrollo empresarial. con una visión universal.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20agricolas%2FZOO_02.jpg?alt=media&token=e6d6113e-a1e5-48f2-b42f-a140569faafe',
    urlVideo: 'https://www.youtube.com/embed/CzOx33r_Q9Q',
    facultad: 'Facultad de ciencias agrarias',
    pregrado: 'ZOOTECNIA',
  },
  {
    id: 38,
    area: '1',
    descripcion:
      'La misión del programa es formar profesionales íntegros y con capacidad de liderazgo. apoyados en la investigación. la extensión y la docencia; para desempeñarse en todas las actividades de las Ciencias Farmacéuticas. en las áreas de los medicamentos. los cosméticos. de los alimentos. de los productos naturales y de otros insumos para la salud. dentro del concepto de la Atención Farmacéutica. para contribuir a la conservación de la salud pública y al mejoramiento de la calidad de vida.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FQCA_FARM.jpg?alt=media&token=26795196-5867-45f3-a876-6a100023efba',
    urlVideo: 'https://www.youtube.com/embed/951VcvLfMX0',
    facultad: 'Facultad de ciencias farmacéuticas y alimentarias',
    pregrado: 'QUÍMICA FARMACÉUTICA',
  },
  {
    id: 39,
    area: '5',
    descripcion:
      'En consonancia con los principios de la Facultad de Comunicaciones, el pregrado en Periodismo tiene como misión formar profesionales con habilidades en la investigación periodística, la capacidad narrativa de manera convergente y una capacidad crítica, ética y moral al ejercer un proceso de mediación comunicativa con la ciudadanía al actuar de manera consciente como intérpretes de una contemporaneidad trazada desde un orden cultural, histórico, político, tecnológico y económico.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FPERIODISMO.jpg?alt=media&token=930b367d-37d3-4695-a84c-da592b97faf9',
    urlVideo: 'https://www.youtube.com/embed/MwaPeEzwAGc',
    facultad: 'Facultad de comunicaciones',
    pregrado: 'PERIODISMO',
  },
  {
    id: 40,
    area: '5',
    descripcion:
      'El programa de Pedagogía busca alimentar las mentes de quienes quieran apropiarse y divulgar el conocimiento. Es fuente de preguntas y respuestas. y. sobre todo. una excusa para compartir y dialogar. para Investigar. diseñar. pensar y. por supuesto. ponerse a prueba en la práctica; encontrar en las comunidades su razón de ser: formar criterios para la convivencia y la vida buena.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/xYCyF2eoE-Q',
    facultad: 'Facultad de educación',
    pregrado: 'PEDAGOGÍA',
  },
  {
    id: 41,
    area: '3',
    descripcion:
      'La Facultad de Odontología está comprometida con la comunidad en la formación de un odontólogo integral con una actitud crítica y responsable. capaz de emprender transformaciones; en la generación. construcción y transmisión de conocimientos con criterios de excelencia académica; y en la prestación de servicios que sean respuesta auténtica a las necesidades. particularmente para el manejo del componente bucal del proceso salud-enfermedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FODONTO.jpg?alt=media&token=dfef204d-b63e-4cad-9c48-68922b9eb956',
    urlVideo: 'https://www.youtube.com/embed/eORAl0gkUeM',
    facultad: 'Facultad de odontología',
    pregrado: 'ODONTOLOGÍA',
  },
  {
    id: 42,
    area: '3',
    descripcion:
      'El programa de Tecnología Biomédica formará personas capaces de intervenir de manera directa en los procesos de transferencia tecnológica biomédica, producción de tecnología, el mantenimiento especializado y la comercialización. Se tratará de profesionales con sólidos conocimientos en ciencias básicas, con destrezas en el manejo de herramientas y equipos para el ensamble y mantenimiento de tecnología biomédica, con habilidades comunicativas y gran conocimiento del sector comercial en el campo biomédico que fortalecerán la industria biomédica en Colombia.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2Fvarios.jpg?alt=media&token=afec9ac4-4adc-42a4-b5f5-f31ccc6524c9',
    urlVideo: 'https://www.youtube.com/embed/0ApT3tzHCIA',
    facultad: 'Facultad de ingeniería',
    pregrado: 'TECNOLOGÍA BIOMÉDICA',
  },
  {
    id: 43,
    area: '1',
    descripcion:
      'La Oceanografía es la ciencia de los océanos, de sus interacciones con los continentes y la atmósfera. Estudia los mares, sus costas, estuarios y lecho marino. Es una disciplina que integra los principios de la biología, la química, la geología, la meteorología y la física para entender los diferentes procesos que gobiernan la dinámica de los océanos y su influencia en el cambio global.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FOCEANOGRAF.jpg?alt=media&token=f4ccf62b-a0e1-4d68-b9fe-e7fe6be6812a',
    urlVideo: 'https://www.youtube.com/embed/4omdFtwZll8',
    facultad: 'Corporación ambiental',
    pregrado: 'OCEANOGRAFÍA',
  },
  {
    id: 44,
    area: '3',
    descripcion:
      'El Gerente de Sistemas de Información en Salud es un profesional capacitado en la gestión de la información en salud. con la habilidad de ordenar e interpretar datos y con base en estos describir una situación existente. comparar las situaciones alcanzadas con las deseadas. analizar y explicar razones obstáculos y problemas. efectos de las acciones ejecutadas y mantiene informada a toda la institución con reportes e indicadores de situaciones actuales y realiza propuestas acerca de las medidas a tomar.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FGER_INFO_SALUD.jpg?alt=media&token=8646249d-0938-4db6-9155-15597a654724',
    urlVideo: 'https://www.youtube.com/embed/RlxrpveG4-w',
    facultad: 'Facultad de salud pública',
    pregrado: 'GERENCIA DE SISTEMAS DE INFORMACIÓN EN SALUD',
  },
  {
    id: 45,
    area: '5',
    descripcion:
      'La misión del programa es la formación inicial y continuada de pedagogos y pedagogas infantiles para la educación y la formación de la infancia en contextos diversos respondiendo de manera crítica a las problemáticas y necesidades de la sociedad contemporánea, desde una perspectiva interdisciplinar, que articule en torno a la investigación, la docencia y la extensión',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FLIC_EDU_INF.jpg?alt=media&token=cef3585b-5da4-4e01-a535-0a0272c77067',
    urlVideo: 'https://www.youtube.com/embed/DHDMK2m3QIE',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN EDUCACIÓN INFANTIL',
  },
  {
    id: 46,
    area: '1',
    descripcion:
      'El Microbiólogo Industrial y Ambiental de la Universidad de Antioquia es un profesional formado integralmente en el marco de la ética. los valores ambientales. con conciencia social. el trabajo interdisciplinario. con capacidades y competencias que. soportadas en los Sistemas de Gestión de la Calidad. lo facultan para participar en procesos de capacitación. investigación y asistencia técnica relacionados con: 1.Desarrollo de aspectos microbiológicos asociados a procesos ambientales e industriales. 2. Participación en equipos de trabajo interdisciplinarios orientados hacia la solución de problemas en el ámbito industrial y ambiental en el que interactúan los microorganismos. 3. Formulación e implementación de procesos de base biotecnológica a nivel de laboratorio. planta piloto y de campo. 4. Apoyo en la implementación de metodologías para la bioprospección y el uso de microorganismos a nivel industrial o ambiental.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FMICROBIOL_IND.jpg?alt=media&token=74ebd16d-ff47-4797-b1fd-d863ca9b79a2',
    urlVideo: 'https://www.youtube.com/embed/f0uilFGLKOA',
    facultad: 'Escuela de microbiología',
    pregrado: 'MICROBIOLOGÍA INDUSTRIAL Y AMBIENTAL',
  },
  {
    id: 47,
    area: '6',
    descripcion:
      'El programa de la Licenciatura está orientado a la formación de pedagogos musicales que puedan desempeñarse tanto en la escuela básica primaria y secundaria. como en institutos especializados. Incluye una sólida formación musical y pedagógica. con conocimientos que permiten abordar la enseñanza musical en el aula de clases y la conformación de agrupaciones musicales escolares.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_MUSICA.jpg?alt=media&token=72ea7d57-57d5-4344-b606-22fe99055e8e',
    urlVideo: 'https://www.youtube.com/embed/sBPsU40NwzQ',
    facultad: 'Facultad de artes',
    pregrado: 'LICENCIATURA EN MÚSICA',
  },
  {
    id: 48,
    area: '4',
    descripcion:
      'El plan de estudios del Ingeniero Acuícola pretende formar un profesional integral. mediante la selección y organización de contenidos de conocimiento en las áreas de ingeniería. socio-humanística. económico - administrativa o complementaria. investigativa y por último el área de profesionalización y profundización en producción acuícola o de los cebaderos específicos.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20agricolas%2FACUICOLA_01.jpg?alt=media&token=34f03b23-3efd-4ca4-aeca-80409fd3488e',
    urlVideo: 'https://www.youtube.com/embed/MelnmPRPmxU',
    facultad: 'Facultad de ciencias agrarias',
    pregrado: 'INGENIERÍA ACUÍCOLA',
  },
  {
    id: 49,
    area: '6',
    descripcion:
      'El programa de Artes Plásticas tiene el propósito de formar profesionales en las artes que estén en capacidad de abordar los problemas de la creación visual con una actitud crítica sólida y coherente con las exigencias contemporáneas del medio. que le permita trascender a una interpretación de los fenómenos sociales y construir propuestas plásticas que tengan incidencia en la sociedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FARTES_PLAST.jpg?alt=media&token=85db0105-c92c-4824-8dbc-9e6eefe7f43e',
    urlVideo: 'https://www.youtube.com/embed/OtI_BxT54Sc',
    facultad: 'Facultad de artes',
    pregrado: 'ARTES PLÁSTICAS',
  },
  {
    id: 50,
    area: '5',
    descripcion:
      'El Departamento de Trabajo Social forma profesionales en Trabajo Social. humanistas y autónomos. con visión global del mundo. capaces de aportar al conocimiento y al desarrollo humano y social. con responsabilidad ética y sentido democrático. A través de la Docencia. la Investigación y la Extensión. soportados en una sólida fundamentación teórica. metodológica y técnica. se desarrolla en la comunidad académica la capacidad analítica. la creatividad y el estímulo del trabajo interdisciplinario. Interactúa con redes y organismos del sector social. fortaleciendo la comunidad científica y académica local. regional. nacional e internacional.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FTRAB_SOC.jpg?alt=media&token=42f7b559-f66d-428b-94f8-89313f9ef579',
    urlVideo: 'https://www.youtube.com/embed/8kOgNeuaUHs',
    facultad: 'Facultad de ciencias sociales y humanas',
    pregrado: 'TRABAJO SOCIAL',
  },
  {
    id: 51,
    area: '2',
    descripcion:
      'El Tecnólogo en Saneamiento Ambiental es un profesional que de manera integral, responde a las demandas de transformación y mejoramiento de la sociedad mediante intervenciones y aportes significativos en sus procesos y trayectorias de desarrollo, con una orientación eminente hacia el desarrollo humano, la sostenibilidad ambiental y la presencia de lo público, en el marco de la salud ambiental.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_SANEAM_AMBIENTAL.jpg?alt=media&token=9cded698-91b0-4e6c-bcb7-5f7ce29556e1',
    urlVideo: 'https://www.youtube.com/embed/pMv_bAKTugI',
    facultad: 'Facultad de salud pública',
    pregrado: 'TECNOLOGÍA EN SANEAMIENTO AMBIENTAL',
  },
  {
    id: 52,
    area: '3',
    descripcion:
      'El programa de Tecnología en Regencia de Farmacia de la Universidad de Antioquia. tiene como misión contribuir a la conservación y promoción de la salud pública. a través de la docencia. la investigación y la extensión. formando un talento humano competente que trascienda e impacte en el medio y en la gestión integral de los productos farmacéuticos y similares. en los establecimientos y servicios farmacéuticos de baja complejidad y como apoyo en los de mediana y alta complejidad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FREG_FARM.jpg?alt=media&token=f27fe9a3-7bfd-4fef-b4fe-75d1fbdd67e1',
    urlVideo: 'https://www.youtube.com/embed/VVTEQgLFQmg',
    facultad: 'Facultad de ciencias farmacéuticas y alimentarias',
    pregrado: 'TECNOLOGÍA EN REGENCIA DE FARMACIA',
  },
  {
    id: 53,
    area: '5',
    descripcion:
      'El Programa de Psicología de la Universidad de Antioquia se ocupa de estudiar las principales teorías sobre los procesos psicológicos a partir de principios científicos. éticos y socio-humanísticos para orientar la reflexión académica. la praxis y la actitud investigativa en los diversos campos de acción de la psicología.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FPSICOLOGIA.jpg?alt=media&token=e287f99f-30b8-4067-ae02-1f2c972d6a3d',
    urlVideo: 'https://www.youtube.com/embed/GdaKB-Eqpbc',
    facultad: 'Facultad de ciencias sociales y humanas',
    pregrado: 'PSICOLOGÍA',
  },
  {
    id: 54,
    area: '3',
    descripcion:
      'Los profesionales egresados del pregrado de Nutrición y dietética. podrán liderar proyectos de investigación en instituciones públicas o privadas y de educación superior que tengan como objetivo generar conocimiento científico relacionado con la alimentación y nutrición humana. participando de manera activa en grupos interdisciplinarios. ',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FNUTRICION.jpg?alt=media&token=d1bde6b4-53f5-41bb-8dc3-ac88662da9a4',
    urlVideo: 'https://www.youtube.com/embed/69bblYJdIKU',
    facultad: 'Escuela de nutrición y dietética',
    pregrado: 'NUTRICIÓN Y DIETÉTICA',
  },
  {
    id: 55,
    area: '3',
    descripcion:
      'El propósito de educativo está enfocado en formar licenciados con capacidad para crear y difundir conocimientos. procedimientos y actitudes relacionadas con el proceso de EDUCABILIDAD y enseñabilidad de la Educación Física. la Actividad Física. el Deporte y la Recreación. en la perspectiva del desarrollo humano. científico. cultural y social. El Licenciado en Educación Física estará en capacidad de diseñar. ejecutar y evaluar procesos pedagógicos y de administración y gestión en el campo de la Educación Física escolar. el entrenamiento deportivo. la actividad física orientada a la salud y la recreación.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FED_FISICA.jpg?alt=media&token=2117f7a7-7d83-478d-95cd-c2637177f17a',
    urlVideo: 'https://www.youtube.com/embed/JCKHoQSvVoc',
    facultad: 'Instituto universitario de educación física y deporte',
    pregrado: 'LICENCIATURA EN EDUCACIÓN FÍSICA',
  },
  {
    id: 56,
    area: '2',
    descripcion:
      'El egresado del programa de Ingeniería Sanitaria de la Universidad de Antioquia podrá trabajar en entidades dedicadas a la prestación de servicios públicos domiciliarios de agua potable y saneamiento y en entidades dedicadas al control de la calidad de los recursos agua. aire y suelo; también podrá desempeñarse como profesional independiente dedicado al diseño. operación. mantenimiento. construcción. interventoría. asesoría. evaluación de impactos y aplicación de la legislación ambiental y de la normalización internacional de obras hidráulicas y sanitarias destinadas al servicio público y privado; en la gestión integral de residuos.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_SANITARIA.jpg?alt=media&token=76e26b96-d4a3-4b21-a622-d891aa85e4d0',
    urlVideo: 'https://www.youtube.com/embed/VJ-GxsBWpWg',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA SANITARIA',
  },
  {
    id: 57,
    area: '2',
    descripcion:
      'Formar integralmente profesionales de pregrado y posgrado con solidez científica. competencia y compromiso social para hacer más productivas y competitivas a las organizaciones nacionales. en lo referente a gestión de operaciones. logística y calidad. Además. el Departamento se dedica a la creación. apropiación y aplicación de conocimientos socialmente relevantes. a través de las actividades de investigación y de extensión de sus profesores y estudiantes. para contribuir al desarrollo sostenible de la región y del país.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_INDUS.jpg?alt=media&token=9b810617-295d-4db6-9ce9-7e2180ef77c0',
    urlVideo: 'https://www.youtube.com/embed/lWENpkQScWc',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA INDUSTRIAL',
  },
  {
    id: 58,
    area: '2',
    descripcion:
      'Un egresado del programa de Ingeniería de Telecomunicaciones de la Universidad de Antioquia. deberá buscar en general caracterizarse en su contexto profesional por: " Desarrollar habilidades para entender y simular. según las leyes y principios físicos. el entorno en el que vive. " Poseer sólidos conocimientos y destrezas para innovar. enfrentar. asimilar y apropiar. a su entorno. los desarrollos tecnológicos y servicios del sector de las telecomunicaciones y la informática. Poseer una capacidad de trabajo en grupo. unas habilidades comunicativas y una posibilidad de desempeño multidisciplinario. que le permitan desarrollar o participar en proyectos integrales. Afines a las telecomunicaciones y la informática. Analizar. diseñar. construir y simular actividades o procesos que involucren procesamiento. transmisión o almacenamiento de la información o servicios asociados con los mismos. " Realizar actividades de investigación. gestión y apropiación tecnológica en telecomunicaciones e informática. Conocer y aplicar la legislación y normatización vigentes en los sectores de telecomunicaciones e informática.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_TELECO.jpg?alt=media&token=38fa7a0a-62fb-49b3-ad95-97bedf11cb46',
    urlVideo: 'https://www.youtube.com/embed/aeko1Gtn5oQ',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA EN TELECOMUNICACIONES',
  },
  {
    id: 59,
    area: '2',
    descripcion:
      'El objetivo primordial de la ingeniería civil consiste en el estudio de las matemáticas y la física con el objeto de entender e interactuar con las fuerzas naturales para poder analizar. calcular. diseñar. simular. optimizar e implementar soluciones a problemas de infraestructura civil de tipo público y privado. incluyendo su construcción. programación y control. con el fin de generar bienestar. desarrollo tecnológico y desarrollo sostenible para la sociedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_CIVIL.jpg?alt=media&token=43382eb8-5bcc-4e95-bc5d-ef233327ad24',
    urlVideo: 'https://www.youtube.com/embed/lYPvT23xBVU',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA CIVIL',
  },
  {
    id: 60,
    area: '2',
    descripcion:
      'El objetivo de la Ingeniería Bioquímica es la aplicación del conocimiento de las ciencias físicas, químicas, biológicas y matemáticas y de la ingeniería en el diseño, análisis, administración, dirección, supervisión y control de procesos y plantas biotecnológicas donde se llevan a cabo transformaciones de tipo bioquímico usando las potencialidades biológicas de los microorganismos, las células animales o vegetales con el fin transformar materias primas hasta obtener bienes y servicios útiles a la sociedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_BIOQCA.jpg?alt=media&token=b9880bfc-6cee-4855-b9a0-671e3319cd02',
    urlVideo: 'https://www.youtube.com/embed/9Jm8ySdS3tg',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA BIOQUÍMICA',
  },
  {
    id: 61,
    area: '2',
    descripcion:
      'El programa está dirigido a bachilleres con curiosidad por conocer y estudiar el ambiente. con interés por la ingeniería. con habilidades en matemáticas y ciencias naturales. y con compromiso frente a la búsqueda de soluciones a los problemas ambientales. Nuestra misión es formar ingenieros ambientales que generen y apliquen sus conocimientos para contribuir al desarrollo regional y nacional. en beneficio del ser humano y del ambiente.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_AMBIENTAL.jpg?alt=media&token=f352bc3f-a2df-4e33-aabd-d8a9c6cd1c46',
    urlVideo: 'https://www.youtube.com/embed/Bkv9OIyvbUs',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA AMBIENTAL',
  },
  {
    id: 62,
    area: '2',
    descripcion:
      'La Ingeniería Agropecuaria tiene como objeto el estudio de la producción agrícola, pecuaria y agroindustrial, orientado bajo el enfoque de “sistemas de producción”, mediante el uso y manejo racional de sus componentes e interacciones, que permitan mejorar la eficiencia, productividad, competitividad y sostenibilidad del sector agropecuario.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_AGROPEC.jpg?alt=media&token=c6770232-b6a7-45c5-b8ff-12fadede6d06',
    urlVideo: 'https://www.youtube.com/embed/uUt9gLiC5qY',
    facultad: 'Facultad de ciencias agrarias',
    pregrado: 'INGENIERÍA AGROPECUARIA',
  },
  {
    id: 63,
    area: '2',
    descripcion:
      'El objetivo de la Ingeniería Agroindustrial es la aplicación del conocimiento de las ciencias físicas, químicas, biológicas, matemáticas y de la ingeniería al diseño y administración de procesos y plantas industriales para dar valor agregado a materias primas agropecuarias, sean estas alimentarias o no, integrando la producción primaria a los procesos de conservación, transporte, transformación y comercialización, teniendo en cuenta principios de sostenibilidad de los recursos naturales con responsabilidad social y ambiental.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FING_AGROIND.jpg?alt=media&token=ea34ea66-cf2f-4647-93e4-7347bb3c7a5f',
    urlVideo: 'https://www.youtube.com/embed/68bq7sa22Tk',
    facultad: 'Facultad de ingeniería',
    pregrado: 'INGENIERÍA AGROINDUSTRIAL',
  },
  {
    id: 64,
    area: '5',
    descripcion:
      'El programa de Gestión en Ecología y Turismo, tiene su fundamento teórico en la construcción y aplicación de los conceptos de turismo, ecología, ciencias sociales y economía, enmarcados en el desarrollo sostenible. Además, requiere la generación de acciones y procesos que involucren a las comunidades locales, permitiendo mejorar la calidad de vida y la protección y conservación de los recursos que los rodean. Igualmente fundamenta aspectos teórico-prácticos del turismo, generando conocimiento que aporten al desarrollo del turismo bajo parámetros de sostenibilidad.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/LU-MGgdb2ts',
    facultad: 'Corporación ambiental',
    pregrado: 'GESTIÓN EN ECOLOGÍA Y TURISMO',
  },
  {
    id: 65,
    area: '5',
    descripcion:
      'El programa tiene como objetivo formar un profesional de la Gestión Cultural con capacidad para entender y comprender los procesos culturales y las actividades vitales involucradas con el desarrollo comunitario y cultural de las regiones; con competencias para apreciar la diversidad, valorar críticamente su desarrollo, propiciando procesos de animación, promoción, creación, divulgación, preservación e investigación de la cultura. ',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FGEST_CULTURAL.jpg?alt=media&token=c61e470c-6fab-4b2f-8f96-bc38f3959b93',
    urlVideo: 'https://www.youtube.com/embed/Uk0swUP7Igs',
    facultad: 'Facultad de artes',
    pregrado: 'GESTIÓN CULTURAL',
  },
  {
    id: 66,
    area: '6',
    descripcion:
      'El egresado de filosofía estará en capacidad de liderar y desarrollar investigaciones interdisciplinarias en los problemas de la filosofía y en relación con las ciencias sociales y humanas. la educación. las artes o las ciencias naturales. en consonancia con su énfasis investigativo durante el programa. Además. podrá desempeñarse en la docencia en Educación Superior. Estará en capacidad de desarrollar y evaluar diferentes actividades relacionadas con los procesos de escritura. redacción y análisis de textos. Podrá desempeñarse como gestor cultural y asesor de equipos interdisciplinarios dedicados al estudio de situaciones de crisis de su comunidad y problemas complejos de la sociedad contemporánea.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FFILOSOFIA.jpg?alt=media&token=d31671e3-9587-4e7d-8f36-3ce0df1ee6db',
    urlVideo: 'https://www.youtube.com/embed/hu7Jj3Mvr-A',
    facultad: 'Instituto de filosofía',
    pregrado: 'FILOSOFÍA',
  },
  {
    id: 67,
    area: '6',
    descripcion:
      'El programa Filología Hispánica pretende formar profesionales que, con una perspectiva interdisciplinar, en especial en los campos de la lengua y la literatura, sean competentes en el diseño, la dirección, la ejecución, la gestión y la divulgación de investigaciones y proyectos relacionados con la lengua, la literatura y las culturas; para desempeñar las labores que desde el campo de lo cultural e intelectual son necesarias en las sociedades actuales en general, y en la sociedad colombiana en particular, tanto en las áreas investigativas, científicas y culturales, como en las empresariales y educativas.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/kPrV4lWN4sY',
    facultad: 'Facultad de comunicaciones',
    pregrado: 'FILOLOGÍA HISPÁNICA',
  },
  {
    id: 67,
    area: '1',
    descripcion:
      'El programa de Ecología de Zonas Costeras busca contribuir a la conservación de los recursos naturales, socioculturales y del medio ambiente natural o creado por el hombre, con la formación de profesionales en el área de la biología con énfasis en los aspectos ambientales, capacitados para identificar, evaluar y ofrecer soluciones a los problemas de las áreas costeras del país.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FECOL_COSTA.jpg?alt=media&token=e5113c0a-c6d0-4b82-a59e-6b07dd2f4571',
    urlVideo: 'https://www.youtube.com/embed/Zu088sNc23c',
    facultad: 'Corporación ambiental',
    pregrado: 'ECOLOGÍA ZONAS COSTERAS',
  },
  {
    id: 68,
    area: '5',
    descripcion:
      'El Pregrado en Desarrollo Territorial es un campo del saber que se ocupa de la gestión del territorio y los diferentes ámbitos que confluyen en su desarrollo desde una perspectiva interdisciplinaria  integral: económica, geográfica, política, ecológica e instrumental; la cual se complementa con cursos para potencializar las competencias de sus estudiantes al servicio de la sociedad.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FDLLO_TERRIT.jpg?alt=media&token=e616e7fa-6cdd-4cab-9df8-dde9f53ada2a',
    urlVideo: 'https://www.youtube.com/embed/ejVIzRaqsSw',
    facultad: 'Facultad de ciencias económicas',
    pregrado: 'DESARROLLO TERRITORIAL',
  },
  {
    id: 69,
    area: '5',
    descripcion:
      'El pregrado de Derecho de la Universidad de Antioquia busca formar abogados con capacidad crítica. con sólidos criterios jurídicos y con suficientes elementos para comprender el derecho -en su dimensión práctica y en su dimensión científica-. la sociedad. la política y el Estado.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FDERECHO.jpg?alt=media&token=333c1e7c-7ca5-4c0e-8ed1-c8fb60a531f7',
    urlVideo: 'https://www.youtube.com/embed/VXHAKTzKJfE',
    facultad: 'Facultad de derecho y ciencias políticas',
    pregrado: 'DERECHO',
  },
  {
    id: 70,
    area: '3',
    descripcion:
      'Los técnicos profesionales en Atención Prehospitalaria de la UdeA están capacitados para brindar soporte básico de vida en el ámbito prehospitalario durante urgencias, emergencias o desastres; asistencia y atención en catástrofes, apoyo médico, de diagnóstico y soporte en el diseño de los planes de emergencias gubernamentales e institucionales.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20medicas%2FDEPORTIVO_02.jpg?alt=media&token=be737d97-e8d5-426a-bf1a-349fddf9c8dd',
    urlVideo: 'https://www.youtube.com/embed/1KtjUHjkQYc',
    facultad: 'Facultad de medicina',
    pregrado: 'ATENCIÓN PREHOSPITALARIA',
  },
  {
    id: 71,
    area: '5',
    descripcion:
      'Al finalizar el programa el ADMINISTRADOR DE EMPRESAS podrá: Ejercer su profesión en el campo de la administración de organizaciones. desempeñarse como asesor o consultor de PYMES y. crear y desarrollar su propia empresa.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FADMON_EMPR.jpg?alt=media&token=b749e37f-c350-4e43-84b1-a7ac34aec370',
    urlVideo: 'https://www.youtube.com/embed/IiJvWoSVDPs',
    facultad: 'Facultad de ciencias económicas',
    pregrado: 'ADMINISTRACIÓN DE EMPRESAS',
  },
  {
    id: 72,
    area: '6',
    descripcion:
      'El programa se denomina Licenciatura en filosofía y conduce al título de Licenciado (a) en filosofía. Su propósito fundamental es la formación de maestros en el área de filosofía. con perfil investigativo y crítico.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_FILO.jpg?alt=media&token=d9e8c481-7d80-4ee8-9872-e8b8fae0528f',
    urlVideo: 'https://www.youtube.com/embed/jjyjeZrw0PY',
    facultad: 'Instituto de filosofía',
    pregrado: 'LICENCIATURA EN FILOSOFÍA',
  },
  {
    id: 73,
    area: '5',
    descripcion:
      'El profesional en archivística de la Universidad de Antioquia estará capacitado para gestionar documentos administrativos e históricos; preparado para desempeñar su labor con base en principios y valores éticos; consciente de la responsabilidad de salvaguardar el patrimonio documental y la memoria de la nación. a través de la aplicación de políticas nacionales. en cumplimiento de las normas legales; capaz de planificar. gestionar y desarrollar servicios archivísticos que beneficien a las instituciones; investigador en las distintas áreas de la disciplina; ; conocedor de la aplicación de las tecnologías de la información y la comunicación a los procesos de administración documental y para la preservación y difusión del patrimonio.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FARCHIVISTICA.jpg?alt=media&token=40817901-15ad-41ac-b0da-967593a41847',
    urlVideo: 'https://www.youtube.com/embed/AI1aM_oH_T0',
    facultad: 'Escuela interamericana de bibliotecología',
    pregrado: 'ARCHIVÍSTICA',
  },
  {
    id: 74,
    area: '5',
    descripcion:
      'Un bibliotecólogo es un agente promotor del cambio social y cultural. gerente de información. con capacidad de gestión. líder en el manejo de información. en creación y la promoción de productos y servicios; capaz de adoptar y adaptar procesos y tecnologías de información. comunicador. investigador y formador en el ámbito de la información en general y de las unidades de información. en específico. ',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FBIBLIO.jpg?alt=media&token=e25089a4-eef9-48ae-9721-340026d7d323',
    urlVideo: 'https://www.youtube.com/embed/6hXFNmWsknQ',
    facultad: 'Escuela interamericana de bibliotecología',
    pregrado: 'BIBLIOTECOLOGÍA',
  },
  {
    id: 75,
    area: '6',
    descripcion:
      'El objeto de estudio ed las ciencias culinarias son las transformaciones culinarias de los alimentos y su conocimiento en los aspectos físicos, químicos, nutricionales y culturales',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FCULINARIA.jpg?alt=media&token=cfcb4283-75a6-4ae4-b9fc-6126fc29c9c1',
    urlVideo: 'https://www.youtube.com/embed/deZDL2c3hIs',
    facultad: 'Facultad de ciencias farmacéuticas y alimentarias',
    pregrado: 'CIENCIAS CULINARIAS',
  },
  {
    id: 76,
    area: '5',
    descripcion:
      'El objetivo central del pregrado es formar politólogos con las herramientas conceptuales. teóricas. intelectuales y humanas. para que comprendan. interpreten y analicen. de manera crítica y reflexiva. los diversos fenómenos de la política contemporánea.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20sociales%2FCCIA_POLITICA.jpg?alt=media&token=9ec5c6bc-6abf-44c8-98d4-51f7215884a9',
    urlVideo: 'https://www.youtube.com/embed/NaNAaY_KiEM',
    facultad: 'Facultad de derecho y ciencias políticas',
    pregrado: 'CIENCIA POLÍTICA',
  },
  {
    id: 77,
    area: '2',
    descripcion:
      'La Universidad está comprometida con la formación integral, por lo tanto el profesional egresado como Ingeniero de Alimentos, posee una sólida estructura científica y técnica enmarcada en una fundamentación humanística e investigativa, es un ciudadano ético, creativo, racional, crítico, con sensibilidad social, con conocimiento en la ingeniería, procesos alimentarios, aseguramiento de la calidad y administración, con profundo respeto por su entorno, capacidad de interactuar en grupos interdisciplinarios, investigar, desarrollar, diseñar, implementar y optimizar las más avanzadas tecnologías limpias y de punta.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fingenieria%20tecnologia%2FTEC_ALIM.jpg?alt=media&token=62e55cea-31af-48f2-9bf6-10e510e76cc0',
    urlVideo: 'https://www.youtube.com/embed/9jeBnqdM2mc',
    facultad: 'Facultad de ciencias farmacéuticas y alimentarias',
    pregrado: 'TECNOLOGÍA DE ALIMENTOS',
  },
  {
    id: 78,
    area: '4',
    descripcion:
      'El programa Tecnología en Gestión de Insumos Agropecuarios forma profesionales íntegros, con criterio, excelencia académica y liderazgo social, en la gestión y administración de establecimientos comercializadores de insumos agropecuarios y medicamentos de uso veterinario, aplicando principios técnicos para el manejo adecuado de productos de origen natural, biológico, sintético o químico, utilizados en el diagnóstico, la prevención, el control, la erradicación y el tratamiento de enfermedades, plagas y otros agentes nocivos que afectan a las especies animales y vegetales.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20agricolas%2FINSUMOS_AGRO_01.jpg?alt=media&token=d9ecafa8-9f55-41dc-97d2-47a89bece8b6',
    urlVideo: 'https://www.youtube.com/embed/nTI5BmgDbz4',
    facultad: 'Facultad de ciencias agrarias',
    pregrado: 'TECNOLOGÍA EN GESTIÓN DE INSUMOS AGROPECUARIOS',
  },
  {
    id: 79,
    area: '1',
    descripcion:
      'La Licenciatura en Educación Básica con Énfasis en Matemáticas propende por un maestro para la educación básica con una sólida formación en el saber disciplinar (matemático) imbricado con el saber didáctico y pedagógico. Nuestra misión es Formar maestros de matemáticas intelectuales. reflexivos. éticos y profesionales de la pedagogía e investigadores en el campo de la Educación Matemática. comprometidos con la formación de ciudadanos responsables y autónomos y con capacidad de enfrentar las problemáticas propias de la matemática educativa.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FLIC_MAT.jpg?alt=media&token=da9f4fbc-7e19-4069-8913-ead3b6ba0a62',
    urlVideo: 'https://www.youtube.com/embed/ytPFqwK65Zk',
    facultad: 'Facultad de educación',
    pregrado: 'LICENCIATURA EN MATEMÁTICAS',
  },
  {
    id: 80,
    area: '5',
    descripcion:
      'El contador público de la Universidad de Antioquia es una persona con significativa capacidad para desenvolverse en el medio contable. Muestra habilidades para el análisis de problemas. contribuyendo al desarrollo de los procesos que encaucen soluciones adecuadas y oportunas. Es razonador. creativo cuando se trata de diseños. tiene sólida formación conceptual. es diligente y dedicado a su trabajo. Manifiesta deseos de superación y perfeccionamiento en los campos personal y profesional.',
    urlCaption: '',
    urlVideo: 'https://www.youtube.com/embed/mNkDMEW9hv4',
    facultad: 'Facultad de ciencias económicas',
    pregrado: 'CONTADURÍA PÚBLICA',
  },
  {
    id: 81,
    area: '1',
    descripcion:
      'El programa de Física tiene el propósito de formar profesionales idóneos en esta ciencia. para lo que cuenta con personal profesoral de alta calidad. capacitado para realizar investigación científica de frontera y con una adecuada dotación de laboratorios de docencia e investigación. Contribuir al desarrollo interdisciplinar a nivel de enseñanza. divulgación. investigación y extensión. Formar egresados que estén en capacidad de enfrentar retos en investigación científica y tecnológica y podrán contribuir al desarrollo de la industria y a la formación de otros profesionales.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fciencias%20naturales%2FFISICA.jpg?alt=media&token=d0cb0df7-4478-41fe-9ed5-fbae54d303f6',
    urlVideo: 'https://www.youtube.com/embed/gnADLZM2VEA',
    facultad: 'Facultad de ciencias exactas y naturales',
    pregrado: 'FÍSICA',
  },
  {
    id: 82,
    area: '6',
    descripcion:
      'El programa Licenciatura en lenguas extranjeras forma docentes de francés e inglés. Otorga el título de Licenciado en lenguas extranjeras. El egresado del programa Licenciatura en lenguas extranjeras está preparado para enseñar inglés y francés. Se forma bajo tres ejes fundantes: el del saber específico inglés y francés que le permite comunicarse de manera escrita y oral en ambas lenguas; el de la pedagogía y la didáctica que lo capacitan para ser docente; y el de la investigación que le propicia una actitud crítico-reflexiva propia de la investigación pedagógica. Está capacitado para ser formador y generador de valores humanos y disciplinares en el campo educativo y social.',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FLIC_LENG_EXTRA.jpg?alt=media&token=500ff0a5-b39d-42a5-80be-d092936c5483',
    urlVideo: 'https://www.youtube.com/embed/V6mFU2IV5cM',
    facultad: 'Escuela de idiomas',
    pregrado:
      'LICENCIATURA EN LENGUAS EXTRANJERAS CON ENFASIS EN INGLÉS Y FRANCÉS',
  },
  {
    id: 83,
    area: '6',
    descripcion: '',
    urlCaption:
      'https://firebasestorage.googleapis.com/v0/b/udeaflix.appspot.com/o/programas%2Fhumanidades%2FTEC_JOYERIA.jpg?alt=media&token=35e1179a-9c07-4d31-ad6f-bd548a8fee10',
    urlVideo: 'https://www.youtube.com/embed/coodwX6NZ9c',
    facultad: 'Facultad de artes',
    pregrado: 'TECNOLOGÍA EN JOYERÍA',
  },
];

export const municipios = [
  {
    codigoDepartamento: '00',
    nombreDepartamento: 'VIRTUAL',
    codigoMunicipio: '00',
    nombreMunicipio: 'VIRTUAL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '001',
    nombreMunicipio: 'MEDELLIN',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '002',
    nombreMunicipio: 'ABEJORRAL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '004',
    nombreMunicipio: 'ABRIAQUI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '021',
    nombreMunicipio: 'ALEJANDRIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '030',
    nombreMunicipio: 'AMAGA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '031',
    nombreMunicipio: 'AMALFI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '034',
    nombreMunicipio: 'ANDES',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '036',
    nombreMunicipio: 'ANGELOPOLIS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '038',
    nombreMunicipio: 'ANGOSTURA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '040',
    nombreMunicipio: 'ANORI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '042',
    nombreMunicipio: 'SANTAFE DE ANTIOQUIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '044',
    nombreMunicipio: 'ANZA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '045',
    nombreMunicipio: 'APARTADO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '051',
    nombreMunicipio: 'ARBOLETES',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '055',
    nombreMunicipio: 'ARGELIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '059',
    nombreMunicipio: 'ARMENIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '079',
    nombreMunicipio: 'BARBOSA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '086',
    nombreMunicipio: 'BELMIRA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '088',
    nombreMunicipio: 'BELLO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '091',
    nombreMunicipio: 'BETANIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '093',
    nombreMunicipio: 'BETULIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '101',
    nombreMunicipio: 'CIUDAD BOLIVAR',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '107',
    nombreMunicipio: 'BRICEÑO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '113',
    nombreMunicipio: 'BURITICA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '120',
    nombreMunicipio: 'CACERES',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '125',
    nombreMunicipio: 'CAICEDO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '129',
    nombreMunicipio: 'CALDAS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '134',
    nombreMunicipio: 'CAMPAMENTO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '138',
    nombreMunicipio: 'CAÑASGORDAS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '142',
    nombreMunicipio: 'CARACOLI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '145',
    nombreMunicipio: 'CARAMANTA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '147',
    nombreMunicipio: 'CAREPA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '148',
    nombreMunicipio: 'EL CARMEN DE VIBORAL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '150',
    nombreMunicipio: 'CAROLINA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '154',
    nombreMunicipio: 'CAUCASIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '172',
    nombreMunicipio: 'CHIGORODO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '190',
    nombreMunicipio: 'CISNEROS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '197',
    nombreMunicipio: 'COCORNA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '206',
    nombreMunicipio: 'CONCEPCION',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '209',
    nombreMunicipio: 'CONCORDIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '212',
    nombreMunicipio: 'COPACABANA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '234',
    nombreMunicipio: 'DABEIBA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '237',
    nombreMunicipio: 'DON MATIAS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '240',
    nombreMunicipio: 'EBEJICO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '250',
    nombreMunicipio: 'EL BAGRE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '264',
    nombreMunicipio: 'ENTRERRIOS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '266',
    nombreMunicipio: 'ENVIGADO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '282',
    nombreMunicipio: 'FREDONIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '284',
    nombreMunicipio: 'FRONTINO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '306',
    nombreMunicipio: 'GIRALDO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '308',
    nombreMunicipio: 'GIRARDOTA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '310',
    nombreMunicipio: 'GOMEZ PLATA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '313',
    nombreMunicipio: 'GRANADA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '315',
    nombreMunicipio: 'GUADALUPE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '318',
    nombreMunicipio: 'GUARNE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '321',
    nombreMunicipio: 'GUATAPE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '347',
    nombreMunicipio: 'HELICONIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '353',
    nombreMunicipio: 'HISPANIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '360',
    nombreMunicipio: 'ITAGUI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '361',
    nombreMunicipio: 'ITUANGO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '364',
    nombreMunicipio: 'JARDIN',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '368',
    nombreMunicipio: 'JERICO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '376',
    nombreMunicipio: 'LA CEJA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '380',
    nombreMunicipio: 'LA ESTRELLA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '390',
    nombreMunicipio: 'LA PINTADA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '400',
    nombreMunicipio: 'LA UNION',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '411',
    nombreMunicipio: 'LIBORINA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '425',
    nombreMunicipio: 'MACEO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '440',
    nombreMunicipio: 'MARINILLA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '467',
    nombreMunicipio: 'MONTEBELLO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '475',
    nombreMunicipio: 'MURINDO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '480',
    nombreMunicipio: 'MUTATA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '483',
    nombreMunicipio: 'NARIÑO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '490',
    nombreMunicipio: 'NECOCLI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '495',
    nombreMunicipio: 'NECHI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '501',
    nombreMunicipio: 'OLAYA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '541',
    nombreMunicipio: 'PEÐOL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '543',
    nombreMunicipio: 'PEQUE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '576',
    nombreMunicipio: 'PUEBLORRICO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '579',
    nombreMunicipio: 'PUERTO BERRIO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '585',
    nombreMunicipio: 'PUERTO NARE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '591',
    nombreMunicipio: 'PUERTO TRIUNFO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '604',
    nombreMunicipio: 'REMEDIOS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '607',
    nombreMunicipio: 'RETIRO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '615',
    nombreMunicipio: 'RIONEGRO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '628',
    nombreMunicipio: 'SABANALARGA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '631',
    nombreMunicipio: 'SABANETA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '642',
    nombreMunicipio: 'SALGAR',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '647',
    nombreMunicipio: 'SAN ANDRES DE CUERQUIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '649',
    nombreMunicipio: 'SAN CARLOS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '652',
    nombreMunicipio: 'SAN FRANCISCO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '656',
    nombreMunicipio: 'SAN JERONIMO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '658',
    nombreMunicipio: 'SAN JOSE DE LA MONTAÑA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '659',
    nombreMunicipio: 'SAN JUAN DE URABA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '660',
    nombreMunicipio: 'SAN LUIS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '664',
    nombreMunicipio: 'SAN PEDRO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '665',
    nombreMunicipio: 'SAN PEDRO DE URABA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '667',
    nombreMunicipio: 'SAN RAFAEL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '670',
    nombreMunicipio: 'SAN ROQUE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '674',
    nombreMunicipio: 'SAN VICENTE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '679',
    nombreMunicipio: 'SANTA BARBARA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '686',
    nombreMunicipio: 'SANTA ROSA DE OSOS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '690',
    nombreMunicipio: 'SANTO DOMINGO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '697',
    nombreMunicipio: 'EL SANTUARIO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '736',
    nombreMunicipio: 'SEGOVIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '756',
    nombreMunicipio: 'SONSON',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '761',
    nombreMunicipio: 'SOPETRAN',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '789',
    nombreMunicipio: 'TAMESIS',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '790',
    nombreMunicipio: 'TARAZA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '792',
    nombreMunicipio: 'TARSO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '809',
    nombreMunicipio: 'TITIRIBI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '819',
    nombreMunicipio: 'TOLEDO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '837',
    nombreMunicipio: 'TURBO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '842',
    nombreMunicipio: 'URAMITA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '847',
    nombreMunicipio: 'URRAO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '854',
    nombreMunicipio: 'VALDIVIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '856',
    nombreMunicipio: 'VALPARAISO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '858',
    nombreMunicipio: 'VEGACHI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '861',
    nombreMunicipio: 'VENECIA',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '873',
    nombreMunicipio: 'VIGIA DEL FUERTE',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '885',
    nombreMunicipio: 'YALI',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '887',
    nombreMunicipio: 'YARUMAL',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '890',
    nombreMunicipio: 'YOLOMBO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '893',
    nombreMunicipio: 'YONDO',
  },
  {
    codigoDepartamento: '05',
    nombreDepartamento: 'ANTIOQUIA',
    codigoMunicipio: '895',
    nombreMunicipio: 'ZARAGOZA',
  },
  {
    codigoDepartamento: '11',
    nombreDepartamento: 'BOGOTÁ',
    codigoMunicipio: '001',
    nombreMunicipio: 'BOGOTÁ',
  },
];
